import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initConfigFromJson } from "@/config";
import "@/shared/styles/globals.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    "Root element not found. Make sure there is a <div id='root'></div> in your HTML."
  );
}

async function bootstrap(container: HTMLElement): Promise<void> {
  await initConfigFromJson();
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

void bootstrap(rootElement);
